<section class="header-img-wrapper space">
    <div class="container-full-img">
        <picture>
            <source media="(min-width: 992px)" srcset="/assets/img/home/muenchen_2018.jpg">
            <source media="(min-width: 480px)" srcset="/assets/img/home/muenchen_2018_middle.jpg">
            <source media="(min-width: 0px)" srcset="/assets/img/home/muenchen_2018_small.jpg">
            <img class="img-responsive" src="/assets/img/home/muenchen_2018.jpg"
                 alt="Alexander Koenig">
        </picture>
    </div>
    <article class="container-full">
        <div class="container">
            <div class="row">
                <div class="col-xs-12 col-sm-8 col-md-6">
                    <div class="container-full-content">
                        <h2>Willkommen bei Alexander&nbsp;Koenig</h2>
                        <p>Ich möchte die Onlinewelt nicht nur schöner, sondern auch nutzerfreundlicher machen.<br />
                            Heutzutage eine gute Webseite zu haben, ist wichtiger denn je... </p>
                        <!--<p>Mein Name ist Alexander Koenig, mit meiner Arbeit möchte Ich die Onlinewelt nicht nur schöner,
                            sondern auch nutzerfreundlicher machen.
                            Eine gute Webseite heutzutage zu haben, ist wichtiger denn je.</p>-->
                    </div>
                </div>
            </div>
        </div>
    </article>
</section>

<!--<app-steps></app-steps>-->
<app-news></app-news>
<app-newsslider></app-newsslider>
<!--<app-werte></app-werte>-->
<!--<app-imagegallery></app-imagegallery>

-->

